import React from 'react';

import Tooltip from 'ui-library/floating-ui/Tooltip';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import {InputChangeEvent} from 'util/Types';

export default function MoleculeLotCheckbox(props: {
  disabled: boolean;
  disabledReason?: string;
  onChange: (checked: boolean) => void;
  checked: boolean;
}): JSX.Element {
  return (
    <div>
      <Tooltip text={props.disabled ? props.disabledReason : undefined}>
        <CheckboxInput
          id="molecule-lot-checkbox"
          label="Configure as a molecule lot"
          checked={props.checked}
          onChange={(e: InputChangeEvent) => {
            props.onChange(e.target.checked);
          }}
          disabled={props.disabled}
          className="u-tiny-spacing-bottom"
        />
      </Tooltip>
    </div>
  );
}
